import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_9: FaireProductEntity = {
  token: "nyc-snack-9",
  type: "product",
  name: "Gourmet Popcorn Mix",
  brandName: "Chelsea Snack Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/63ffb91816c25207723c2bcaf13ae379b45e654f4e4289d7b657811f9d25f688.webp",
  priceDollars: 10,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/63ffb91816c25207723c2bcaf13ae379b45e654f4e4289d7b657811f9d25f688.webp",
  weight: 0.5,
  dimensions: {
    width: 5,
    height: 7,
    depth: 3,
  },
  description: "Handcrafted gourmet popcorn in sweet and savory flavors",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "artisanal"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
